import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./PaymentSuccess.css";
import "./PaymentReceipt.css";
// import { useAuth } from "../../Store/AuthContext";
import { formatPrice } from "../Others/ImportantFunction";
import PaymentSuccessReciptMoudle from "./PaymentSuccessReciptMoudle";
// import LegalBradcrumeSection from "../Community/LegalBradcrumeSection";

export default function PaymentSuccess({
  Paymentdata,
  paid_type_status,
  showBordersStyle,
  showTextStyle,
}) {
  const [showReceipt, setShowReceipt] = useState(false);

  return (
    <>
      {/* <LegalBradcrumeSection Pagename={"Payment Success"} /> */}

      <div className="payment-success-container">
        <div className="success-card">
          <div className="paymentSuccessheader">
            <div className="checkmark">
              <i className="fa fa-check" aria-hidden="true"></i>
            </div>
            <h1 className="m-0">Payment Successfull!</h1>
          </div>

          {/* <div className="divider"></div> */}

          <div className="PayemntSuccedetails_section">
            <h3>
              <i className="fa fa-info-circle me-2"></i>Transaction Details
            </h3>

            <table className="Paymentdetails_table">
              <tbody>
                {Paymentdata && Paymentdata.payu_txnid && (
                  <tr>
                    <td className="label">Transaction ID</td>
                    <td>{Paymentdata.payu_txnid}</td>
                  </tr>
                )}
                {Paymentdata && Paymentdata.order_id && (
                  <tr>
                    <td className="label">Order ID.</td>
                    <td>{Paymentdata.order_id}</td>
                  </tr>
                )}
                {Paymentdata && Paymentdata.recept_no && (
                  <tr>
                    <td className="label">Receipt No.</td>
                    <td>{Paymentdata.recept_no}</td>
                  </tr>
                )}
                {Paymentdata && Paymentdata.amount && (
                  <tr>
                    <td className="label">Amount</td>
                    <td className="text-primary">
                      {formatPrice(Paymentdata.amount)}
                    </td>
                  </tr>
                )}
                {Paymentdata && Paymentdata.discountamount !== "0" && (
                  <tr>
                    <td className="label">Discount</td>
                    <td>{Paymentdata.discountamount}</td>
                  </tr>
                )}
                {Paymentdata && Paymentdata.paid_status && (
                  <tr>
                    <td className="label">Status</td>
                    <td>{paid_type_status}</td>
                  </tr>
                )}
                {Paymentdata && Paymentdata.payment_mode && (
                  <tr>
                    <td className="label">Payment Mode</td>
                    <td>{Paymentdata.payment_mode}</td>
                  </tr>
                )}
                {Paymentdata && Paymentdata.date && (
                  <tr>
                    <td className="label">Payment Date</td>
                    <td>{Paymentdata.date}</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className="divider"></div>
          <div className="paymentsuccessbtnFooter">
            <Link
              to="/"
              className="theme-btn btn-style-three submitbtn"
              style={{ marginRight: "12px" }}
            >
              <i className="fa fa-home mx-2" aria-hidden="true"></i> Go to Home
            </Link>
            <button
              className="theme-btn btn-style-three submitbtn"
              style={{ marginRight: "12px" }}
              onClick={() => setShowReceipt(true)}
            >
              <i className="fa fa-download mx-2" aria-hidden="true"></i>{" "}
              Download Receipt
            </button>
          </div>

          <PaymentSuccessReciptMoudle
            show={showReceipt}
            onClose={() => setShowReceipt(false)}
            Paymentdata={Paymentdata}
            paid_type_status={paid_type_status}
            showBordersStyle={showBordersStyle}
            showTextStyle={showTextStyle}
          />
        </div>
      </div>
    </>
  );
}
